export enum FileType {
    PDF = '.pdf',
    PNG = '.png',
    CSV = '.csv',
    XLSX = '.xlsx',
    ZIP = '.zip',
}
